import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
  search: {
    params: SearchParams.Company;
    ids: string[];
  };
};

export const adapter = createEntityAdapter<Model.Company>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'company',
  initialState: adapter.getInitialState<State>({
    loading: false,
    search: {
      ids: [],
      params: {},
    },
  }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.Company[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.Company>) {
      adapter.upsertOne(state, action);
      state.search.ids = [...(state.search.ids || []), action.payload.id];
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    removeEntity(state, action: PayloadAction<Model.Company>) {
      adapter.removeOne(state, action.payload.id);
      state.search.ids = (state.search.ids || []).filter(
        (id) => id !== action.payload.id,
      );
    },
    updateSearch(state, action: PayloadAction<State['search']>) {
      state.search = action.payload;
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.company,
);

export const selectCompanyBySearch = createSelector(
  selector.selectAll,
  selector.selectEntities,
  (state: RootState) => state.model.company.search,
  (companies, entities, { params, ids }) => {
    if (params.q || params.industries || params.is_hidden) {
      return ids.map((id) => entities[id]!);
    }
    return companies;
  },
);

export { reducer };
export default actions;
